<template>
  <div>
    <CCard>
      <CCardHeader class="d-flex">
        Buyer Payment History for

        <router-link
          :to="{ name: 'BuyerAccountDetails', params: { id: getSafe(() => buyerAccountDetails.id)} }"
          target="_blank"
          class="ml-1"
        >
          <strong>{{ getSafe(() => buyerAccountDetails.name) }}</strong>

          <CIcon
            name="cil-external-link"
            size="custom"
            class="ml-1"
          />
        </router-link>

        <CButton
          color="info"
          class="ml-auto"
          size="sm"
          :to="{
            name: 'BuyerPaymentsList',
            query: { accountId: accountId }
          }"
          target="_blank"
        >
          View Pending Invoices
          <CIcon
            name="cil-external-link"
            size="custom"
            class="ml-1"
          />
        </CButton>

        <CButton
          color="info"
          class="ml-2"
          size="sm"
          :to="{
            name: 'BuyerPaymentsList',
            query: { accountId: accountId, paymentStatus: 'Paid' }
          }"
          target="_blank"
        >
          View Paid Invoices
          <CIcon
            name="cil-external-link"
            size="custom"
            class="ml-1"
          />
        </CButton>
      </CCardHeader>

      <CCardBody>
        <div
          v-if="isLoading"
          :style="{ height: '80vh' }"
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <CSpinner
            style="width: 4rem; height: 4rem"
            color="info"
            grow
          />
        </div>

        <div v-else>
          <BuyerPaymentHistoryList :payments="paymentHistory" />
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import startCase from 'lodash.startcase'

import BillingAPI from '@/api/billing.api'
import BuyerPaymentHistoryList from './BuyerPaymentHistoryList.vue'
import { dateTimeFormat } from '@/utils'

function getPaidByFromDescriptionForManualAdjustment(description) {
  if (!description) {
    return ''
  }

  return description.split('(')?.[0]
}

export default {
  name: 'BuyerAccountPaymentHistory',

  components: {
    BuyerPaymentHistoryList,
  },

  data() {
    return {
      accountId: '',
      isLoading: false,

      paymentHistory: []
    }
  },

  computed: {
    ...mapState('accounts', [
      'buyerAccountDetails',
    ]),
  },

  async created () {
    this.accountId = this.$route.params.id

    if (this.accountId && this.buyerAccountDetails !== this.accountId) {
      await this.getBuyerAccountDetails(this.accountId)
    }

    document.title = `Payment History for ${this.buyerAccountDetails.name}`

    await this.getBuyerAccountPaymentHistory(this.accountId)
  },

  methods: {
    ...mapActions('accounts', [
      'getBuyerAccountDetails',
    ]),

    async getBuyerAccountPaymentHistory(accountId) {
      try {
        this.isLoading = true
        const response = await BillingAPI.getBuyersPaymentHistory(accountId)
  
        this.paymentHistory = response.data.map(payment => {
          return {
            ...payment,
            paidByName: payment.transactionType === 'ManualAdjustment' ? getPaidByFromDescriptionForManualAdjustment(payment.paymentDescription) : payment.paidBy?.name,
            formattedPaymentDate: dateTimeFormat.format(new Date(payment.paymentDate)),
            transactionType: startCase(payment.transactionType)
          }
        })
      } catch (error) {
        //
      } finally {
        this.isLoading = false
      }
    }
  },
}
</script>
<style>
  
</style>